<template>
  <v-layout wrap>
    <jobs-list :jobs="loadJobs"></jobs-list>
    <v-pagination class="ml-2 mt-2" v-if="jobs.length>=1"
        v-model="currentPage"
        :length="Math.ceil(jobs.length/perPage)"
    ></v-pagination>
  </expert-layout>
  </v-layout>
</template>

<script>
import JobsList from "../_components/listing.vue";
import { mapGetters } from 'vuex';
export default {
  components: {
    JobsList
  },
  computed: {
    ...mapGetters(["user"]),
    loadJobs() {
      return this.jobs.slice((this.currentPage*this.perPage - this.perPage), ((this.currentPage*this.perPage - this.perPage)+this.perPage))
    }
  },
  data() {
    return {
      jobs: [],
      currentPage: 1,
      perPage: 10
    };
  },
  method: {
    onPageChange(page) {
      console.log(page);
    }
  },
  created() {                
    this.$store
      .dispatch("get", "/expert/assignment/" + this.user._id)
      .then(res => {
        this.jobs = res.assignments;
      });
  }
};
</script>
